/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Trans } from 'react-i18next';

import { GoogleConsentCookieBanner } from '@uncinc/uncinc-react-kitchen-sink';

import useRoutes from '../../hooks/useRoutes';
import useCookie from '../../hooks/useCookie';

import './style.scss';

const Cookie = () => {
  const { privacy } = useRoutes();
  const { updateConsent } = useCookie();

  return (
    <GoogleConsentCookieBanner showAcceptOnlyNeededSelections>
      <p className="body--small">
        <Trans
          i18nKey="cookies.intro"
          components={{
            cookie: <a href={`${privacy}#cookies`} />,
            privacy: <a href={privacy} />,
            update: <button className="textual-link p-0" type="button" onClick={updateConsent} />,
          }}
        />
      </p>
    </GoogleConsentCookieBanner>
  );
};

export default Cookie;
